/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@mui/material/Grid'; 

import { useStyles } from './styles';
import Tile from './tile';
import useWidgetTheme from '../../commons/widgetTheme';
import useUIStates from '../../store/models/uistates/useUIStates';

function ScheduleList (props) {
    const {
        schedules = [],
        elementsHeight = 0,
    } = props;
 
    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const classes = useStyles({
        widget,
        widgetTheme,
        schedules,
        elementsHeight,
    });

    const {
        selecteDeselectSchedule,
        selectedSchedules,
    } = useUIStates();
    
    function renderSchedules () {
        if (isEmpty(schedules)) {
            return (<React.Fragment></React.Fragment>);
        }
  
        return schedules.map((data, index) =>{
            let selected = false;
            if (selectedSchedules[data.id]) {
                selected = true;
            }
           
            return (<Tile
                id={`${data.id}-${index}`}
                key={`schedule-${data.id}`}
                selected={selected}
                data={data}
                widget={widget}
                widgetTheme={widgetTheme}
                onClick={(data) => {
                    selecteDeselectSchedule(data.id);
                }}
            />);
        });
    }

    return (
        <React.Fragment>
            <Grid
                id="content"
                className={classes.list}
            >
                <Grid className={classes.listContent}>
                    { renderSchedules() }
                </Grid>
            </Grid>           
        </React.Fragment>
    );
}

ScheduleList.propTypes = {
    schedules: PropTypes.array,
    elementsHeight: PropTypes.any,
};

export default observer(ScheduleList);